const friends = [
    { id: 1, name: 'John Doe', color: '#467a4d' },
    { id: 2, name: 'Jane Smith', color: '#4d74a7' },
    { id: 3, name: 'Mark Johnson', color: '#a74d4d' },
    { id: 4, name: 'Emily Davis', color: '#a74da0' },
    { id: 5, name: 'Paul Walker', color: '#4da75b' },
    { id: 6, name: 'Lucy Hale', color: '#a7734d' },
    { id: 7, name: 'Chris Lee', color: '#b8a74d' },
    { id: 8, name: 'Diana Ross', color: '#7b4da7' }
  ];

  export default friends;